import script from "./motion-second-modal.vue?vue&type=script&lang=js"
export * from "./motion-second-modal.vue?vue&type=script&lang=js"

import "./motion-second-modal.vue?vue&type=style&index=0&id=b4ecd270&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ecd270"]])

export default __exports__